import Card from '../layout/Card';
import SkillsItem from './SkillsItem';
import classes from './Skills.module.css';
import html from '../img/html.png';
import css from '../img/css.png';
import js from '../img/js.png';
import react from '../img/react.png';
import next from '../img/next.png';
import git from '../img/git.png';
import bootstrap from '../img/bootstrap.png';
import tailwind from '../img/tawilwind.png';


const DUMMY_Data = [
  {
    id: 'm1',
    name: 'Html',
    description: '',
    image: html,
    detail: [ 'making declaretive and reuseable code ',
    '  important tags and elements to use as a developer',
' seo related tags to use',
' simplifyied code and components',
'more than 3 years experince in html'
]
  },
  {
    id: 'm2',
    name: 'Css',
    description: '',
 image: css ,
    detail: [ 'including css preprocessors like scss , sass ',
    ' responsive design layout & fundemental',
' bootstrap & tailwind as a framework',
' more than 24 templates inculding css feauters'
]
  }, 
  {
    id: 'm10',
    name: 'Bootstrap',
    description: '',
    image: bootstrap,
    detail: [ 'worked with bootstarp grid system and flex box ',
    '  implementing responsive designs',
' declaretive pieaces of code'
]
  },
  {
    id: 'm10.5',
    name: 'Tailwind',
    description: '',
    image:tailwind,
    detail: [ 'tail wind basics and feauters ',
    '  implementing responsive designs',
' declaretive pieaces of code'
]
  },
  {
    id: 'm3',
    name: 'JavaScript',
    description: '',
    image:js,
    detail: [ ' experienced at importand feauters of javascirpt including :',
    '  fundemental basic to advanced',
' es6 feauters in use ',
' reuseable and declaretive code ',
'functional programming ',
'asynchornus concepts and feauters',
'dom events and fetch requests',
'connecting to a backend ',
'api concepts and feauters '
]
  },
  {
    id: 'm4',
    name: 'React js',
    description: '',
    image:react,
    detail: [ ' react fundemental (hooks , jsx , state mangement)',
    '  working with functional components',
    'more than 12 react app templates',
' familiar with context and redux',
' react router and dynamic routing in use',
'readable and reusable components',
'connecting to a backend server (firebase mostly used)',
'familar with next js & ssr',
'3rd party libraries and npm packages'
]
  },
  {
    id: 'm4.5',
    name: 'Git',
    description: '',
   image:git,
    detail: [ 'important feauters of git in use',
    ' familiar with scrum ',
' git commands ',
' moore than 22 templates pushed to git',
]
  }, 
  {
    id: 'm9',
    name: 'Next js',
    description: '',
  image:next,
    detail: [ 
    ' familiar with basics of ssr',
'  connecting to a backend and http requests'
]
  },
 
  {
    id: 'm11',
    name: 'Rest api',
    description: '',
    price: 18.99,
    detail: [ ' worked with pagination ',
    ' familiar with basic fundemental ',
' api methods to include',
'familiar with axios and postman'
]
  },
];



const Skills = (props) => {





  const skillsList = DUMMY_Data.map((meal) => (
 
    <SkillsItem
      key={meal.id}
      id={meal.id}
      name={meal.name}
      description={meal.description}
      image={meal.image}
      onClick={ () => {
       props.onShowCart(meal)
      }}
    />
  ));

  return (
    <section className={classes.meals}>
      <Card >
        <ul>{skillsList}</ul>
      </Card>
    </section>
  );
};

export default Skills;